// Legacy Shopify link safeguard.
// monthlypops.com used to be a Shopify storefront. Customer links such as order
// status, return labels, cart and checkout live on Shopify — NOT on this app.
// If someone hits one of those paths on this site, forward them to the Shopify
// store domain so the links keep working.
//
// NOTE: edit SHOPIFY_STORE if your Shopify domain changes.
const SHOPIFY_STORE = "monthly-pops.myshopify.com";

const SHOPIFY_PREFIXES = [
  "/account",
  "/orders",
  "/cart",
  "/checkout",
  "/products",
  "/collections",
  "/pages",
  "/policies",
  "/apps",
  "/tools",
  "/services",
];

export function maybeRedirectToShopify() {
  if (typeof window === "undefined") return false;
  const { pathname, search, hash } = window.location;

  const isShopifyPath =
    /\/return_labels\//.test(pathname) ||
    SHOPIFY_PREFIXES.some((p) => pathname === p || pathname.startsWith(p + "/"));

  if (isShopifyPath) {
    window.location.replace(`https://${SHOPIFY_STORE}${pathname}${search}${hash}`);
    return true;
  }
  return false;
}
